<efp-app-header
  class="no-header-shadow"
  [isNavStep]="true"
  navLink="/homepage"
  title="{{plan?.name}}"
  [planId]="planId"
  [webCollapsableEnabled]="true"
  [showTitleOnWeb]="true">
  <ng-container buttons *ngIf="plan">
    <button
      [disabled]="efpExportService.isLoading"
      class="headerbar-action"
      (click)="efpExportService.showShareDialog(plan)">
      <div class="headerbar-action-icon">share</div>
    </button>
  </ng-container>
</efp-app-header>
<efp-sidebar-container [sidebarPosition]="SidebarPosition.RIGHT">
  <ng-container
    *ngIf="onboardingHintKey$ | async as onboardingHintKey"
    [efpOnboardingTrigger]="onboardingHintKey"
    [triggeredBy]="TriggerType.COMPONENT_RENDERED">
    <efp-onboarding-hints [onboardingHintSeriesKey]="onboardingHintKey"> </efp-onboarding-hints>
  </ng-container>
  <div
    class="drawing-area-container"
    efpKeyboardShortcut
    (deletionShortcut)="onDelete()"
    (numberShortcut)="changeCycleNumberKeyboardListener($event)"
    (ctrlZShortcut)="undo()"
    (ctrlYShortcut)="redo()">
    <efp-planner
      #efpPlanner
      [disabled]="!!planReadOnly"
      [initialize]="pageReadyForPlanner"
      [showScale]="false"
      [scaleUnit]="unit"
      [scaleLabel]="'PLAN.SCALE' | translate"
      (ready)="onPlannerInitialized()"
      (interactionDragged)="onMouseDragged($event)"
      (interactionDown)="onMouseDown($event)"
      (interactionUp)="onMouseUp($event)"
      (interactionMoved)="onMouseMoved($event)"
      (zoomChanged)="onZoomUpdated($event)"
      (panChanged)="onPanUpdated($event)">
    </efp-planner>
    <efp-measurement-legend
      [wallHeight]="planSettings ? planSettings.wallHeight : undefined"
      [slabThickness]="planSettings ? planSettings.slabThickness : undefined"
      [slabHeight]="planSettings ? planSettings.slabHeight : undefined"
      [measurementUnitPlanner]="planSettings ? planSettings.measurementUnit : undefined"
      [buildingType]="plan ? plan.buildingType : undefined"></efp-measurement-legend>
    <efp-dimensions
      *ngIf="this.planVisibilitySettings?.showCycleDimensions"
      [wallHeight]="planSettings?.wallHeight"
      [measurementUnit]="model?.drawSetting?.measurementUnit"
      [cycleDimensionValuesForCalculation]="this.renderService?.circumferenceSubject$ |async"></efp-dimensions>
    <efp-cycle-editor
      #cycleEditor
      *ngIf="selectionService.isLengthLabelSelectionOpen && !isMobile"
      overlay
      [style.left.px]="measurementEditorOverlayPosition.x"
      [style.top.px]="measurementEditorOverlayPosition.y"
      [style.position]="'absolute'"
      [style.min-width]="labelWidth + 'px'"
      [selectedMeasure]="selectionService.selectedLengthLabel"
      [snappingLine]="selectionService.selectedSnappingLine"
      [selectedBoundary]="selectionService.selectedCycleBoundary"
      [unit]="unit"
      [plan]="this.plan"
      [mobileLayout]="false"
      (closeMenu)="moveBoundary($event)">
    </efp-cycle-editor>
    <efp-cycle-selector
      *ngIf="this.selectionService.selectedCycleSymbol; let selectedCycleSymbol"
      efpKeyboardShortcut
      [selectedCycleSymbol]="selectedCycleSymbol"
      [canvasZoom]="planner.canvasZoom"
      [canvasBounds]="planner.canvasBounds"
      (escShortcut)="this.closeCycleNumberSelector()"
      (newNumberForCycle)="this.changeCycleNumberFromCycleSelector($event, selectedCycleSymbol.cyclePosition)">
    </efp-cycle-selector>
    <efp-cycles-context-menu
      *ngIf="selectionService.selectedCycleBoundary && (!selectionService.isLengthLabelSelectionOpen || selectionService.showBoundaryWithLengthLabel) && !selectionService.clickedCycleBoundaryForDrag"
      efpKeyboardShortcut
      [cycleBoundary]="this.selectionService.selectedCycleBoundary"
      [canvasZoom]="planner.canvasZoom"
      [canvasBounds]="planner.canvasBounds"
      [cycleRenderService]="renderService"
      (escShortcut)="this.closeCycleContextMenu()"
      (deleteSelected)="deleteSelectedBoundary()"
      (switchCycle)="this.switchCycles($event)"
      (newNumberForCycle)="this.changeCycleNumberFromCycleSelector($event.newNumber, $event.cyclePosition)">
    </efp-cycles-context-menu>
  </div>

  <efp-bottom-menu-container
    *ngIf="plannerInitialized && model && renderService && plan && !planReadOnly">
    <efp-primary-planner-toolbar
      *ngIf="planVisibilitySettings"
      [renderService]="renderService"
      [model]="model"
      [planVisibilitySettings]="planVisibilitySettings">
      <efp-undo-redo
        [history]="history"
        (undo)="undo()"
        (redo)="redo()"
        [selectionOpen]="selectionService.isLengthLabelSelectionOpen"></efp-undo-redo>
      <efp-toolbar-divider></efp-toolbar-divider>
      <button
        class="action-icon action-icon-large"
        *ngIf="plan"
        [routerLink]="['/drawingsettings', plan.id]"
        efpTooltip
        [tooltipTitle]="('TOOLBAR.DRAWING_SETTINGS' | translate)"
        data-test-selector="cycles-drawing-settings">
        settings
      </button>
    </efp-primary-planner-toolbar>
  </efp-bottom-menu-container>
  <efp-context-menu-center-button-container
    [useCenterView]="true"
    [centerContextMenu]="true"
    [model]="model">
    <ng-container *ngIf="selectionService.isLengthLabelSelectionOpen && isMobile">
      <efp-cycle-editor
        #cycleEditor
        [selectedMeasure]="selectionService.selectedLengthLabel"
        [snappingLine]="selectionService.selectedSnappingLine"
        [selectedBoundary]="selectionService.selectedCycleBoundary"
        [unit]="unit"
        (closeMenu)="moveBoundary($event)"
        [mobileLayout]="isMobile">
      </efp-cycle-editor>
    </ng-container>
  </efp-context-menu-center-button-container>
  <ng-container *ngIf="plan" rightSidebar>
    <efp-navbar
      currentStep="cycles"
      [planId]="plan.id"
      [planType]="plan.buildingType"
      [enableNavigation]="false"
      [planSettings]="planSettings"
      (navButtonClicked)="onNextClicked($event)">
    </efp-navbar>
  </ng-container>
</efp-sidebar-container>
